import { LoadingOutlined_str } from '@zenlayer/zen-design-icons';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { error } from '../_util/devConsoleLog';
import insertRipple from '../_util/insertRipple';
import SvgIcon from '../svg-icon';
import ButtonGroup from './button-group';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Button = props => {
  var _icon$props, _icon$props2;
  const {
    type = 'primary',
    size = 'm',
    special,
    danger,
    textBaseColor,
    hovered,
    loading,
    disabled,
    icon,
    width,
    htmlType = 'button',
    linkProps,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    children,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-button");
  const hasLabel = children !== undefined;
  const classes = classNames(baseClassName, className, {
    ["".concat(baseClassName, "-").concat(type)]: !!type,
    ["".concat(baseClassName, "-").concat(size)]: !!size,
    ["".concat(baseClassName, "-danger")]: (type === 'primary' || type === 'normal' || type === 'text') && !!danger,
    ["".concat(baseClassName, "-special")]: (type === 'primary' || type === 'normal' || type === 'text') && !danger && !!special,
    ["".concat(baseClassName, "-textBaseColor")]: (type === 'normal' || type === 'text' || type === 'primary') && !danger && !special && !!textBaseColor,
    ["".concat(baseClassName, "-loading")]: !!loading,
    ["".concat(baseClassName, "-disabled")]: !!disabled,
    ['hovered']: !!hovered,
    ["onlyIcon"]: !hasLabel
  });
  const iconNode = loading ? /*#__PURE__*/_jsx(SvgIcon, {
    spin: true,
    svgStr: LoadingOutlined_str,
    className: "buttonIcon",
    style: {
      marginRight: hasLabel ? 8 : 0
    }
  }) : icon ? ( /*#__PURE__*/React.cloneElement(icon, {
    className: classNames('buttonIcon', (_icon$props = icon.props) === null || _icon$props === void 0 ? void 0 : _icon$props.className),
    style: {
      ...((_icon$props2 = icon.props) === null || _icon$props2 === void 0 ? void 0 : _icon$props2.style),
      marginRight: hasLabel ? 8 : 0
    }
  })) : null;
  error(!!icon && ! /*#__PURE__*/React.isValidElement(icon), 'Button', ' The icon attribute must be React.ReactElement');
  let innerNode = /*#__PURE__*/_jsx("span", {
    children: children
  });
  if (type === 'link') {
    if ((linkProps === null || linkProps === void 0 ? void 0 : linkProps.to) === undefined) {
      error(true, 'Button', 'The Link component must have the [linkProps.to] attribute.');
      innerNode = /*#__PURE__*/_jsx("span", {});
    } else {
      innerNode = /*#__PURE__*/_jsx(Link, {
        ...linkProps,
        children: true
      });
    }
  }
  return /*#__PURE__*/_jsxs("button", {
    ...restProps,
    ref: ref => {
      insertRipple({
        ref
      });
    },
    type: htmlType,
    className: classes,
    style: {
      ...style,
      width
    },
    disabled: disabled || loading,
    children: [iconNode, innerNode]
  });
};
Button.Group = ButtonGroup;
Button.__ANT_BUTTON = true; // 解决Tooltips问题 https://github.com/react-component/tooltip/issues/18

export default Button;